import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/canteen/inventory/product-group",
        component: List,
        name: "inventory.product.group",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/canteen/inventory/product-group/create",
        component: Create,
        name: "inventory.product.group.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/canteen/inventory/product-group/:id/edit",
        component: Edit,
        name: "inventory.product.group.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
